import { useRoutes, useNavigate } from "react-router-dom";
// 导入路由
import { Router } from './routes'
import './App.css';
function App() {

  // 动态建设routes
  const element = useRoutes(Router)
  return (
    <div className="App">

      {element}

    </div>

  );
}

export default App;
